import React from 'react';
import styled from '@emotion/styled';
import { useStaticQuery, graphql } from "gatsby"
import Sponsor from './Sponsor';
import * as breakpoint from '../../styles/breakpoints.module.scss';

const SponsorsList = ({type}) => {
  const data = useStaticQuery(graphql`

  query SponsorsListSection {
    list : allSponsor(sort: {fields: order, order: ASC}, filter: {data: {status: {eq: "publish"}}}) {
      edges {
        node {
          brand {
            ...localizedContent
          }
          company {
            ...localizedContent
          }
          data {
            ...localizedContent
          }
          description {
            ...localizedContent
          }
          url {
            ...localizedContent
          }
          campaign_url {
            ...localizedContent
          }
          localeLogo {
            ...localizedImages
          }
        }
      }
    }
  }`);

  const { list } = data;


  return (<ListWrapper type={type}>
    {list.edges.map((item,index) => <Sponsor data={item.node} type={type} key={`sponsor_${index}`}/>)}
  </ListWrapper> );
}
 
export default SponsorsList;

const ListWrapper = styled.div`
  display:flex;
  flex-wrap: wrap;
  margin:0 auto;

  ${props => props.type === "plainList" ? `
     max-width:1160px;
    justify-content:center;
    margin:48px auto 24px;
    @media only screen and (max-width: ${breakpoint.smMax}){
      padding:0 48px;
      margin:32px auto 16px;
    }
    @media only screen and (max-width: ${breakpoint.xsMax}){
      padding:0 16px;
      margin:16px auto 0px;
    }
  ` : `
  max-width:1392px`}
`
